export const TYPE_MEMBER = 'TYPE-MEMBER';
export const TYPE_REQUEST = 'TYPE-REQUEST';